module.exports = __webpack_public_path__ + "static/media/500.b038a3f1.png";